Handlebars.registerHelper('uppercase', function(str) {
  if (typeof(str) != 'string'){
    return '';
  }
  return str.toUpperCase();
});

Handlebars.registerHelper('safestring', function(value) {
  return new Handlebars.SafeString(value);
});

Handlebars.registerHelper('json', function(value) {
  return JSON.stringify(value);
});

/**
 * If Equals
 * if_eq this compare=that
 */
Handlebars.registerHelper('if_eq', function(context, options) {
  if (context == options.hash.compare)
    return options.fn(this);
  return options.inverse(this);
});

/**
 * Unless Equals
 * unless_eq this compare=that
 */
Handlebars.registerHelper('unless_eq', function(context, options) {
  if (context == options.hash.compare)
    return options.inverse(this);
  return options.fn(this);
});

/**
 * If Greater Than
 * if_gt this compare=that
 */
Handlebars.registerHelper('if_gt', function(context, options) {
  if (context > options.hash.compare)
    return options.fn(this);
  return options.inverse(this);
});

/**
 * Unless Greater Than
 * unless_gt this compare=that
 */
Handlebars.registerHelper('unless_gt', function(context, options) {
  if (context > options.hash.compare)
    return options.inverse(this);
  return options.fn(this);
});

/**
 * If Less Than
 * if_lt this compare=that
 */
Handlebars.registerHelper('if_lt', function(context, options) {
  if (context < options.hash.compare)
    return options.fn(this);
  return options.inverse(this);
});

/**
 * Unless Less Than
 * unless_lt this compare=that
 */
Handlebars.registerHelper('unless_lt', function(context, options) {
  if (context < options.hash.compare)
    return options.inverse(this);
  return options.fn(this);
});

/**
 * If Greater Than or Equal To
 * if_gteq this compare=that
 */
Handlebars.registerHelper('if_gteq', function(context, options) {
  if (context >= options.hash.compare)
    return options.fn(this);
  return options.inverse(this);
});

/**
 * Unless Greater Than or Equal To
 * unless_gteq this compare=that
 */
Handlebars.registerHelper('unless_gteq', function(context, options) {
  if (context >= options.hash.compare)
    return options.inverse(this);
  return options.fn(this);
});

/**
 * If Less Than or Equal To
 * if_lteq this compare=that
 */
Handlebars.registerHelper('if_lteq', function(context, options) {
  if (context <= options.hash.compare)
    return options.fn(this);
  return options.inverse(this);
});

/**
 * Unless Less Than or Equal To
 * unless_lteq this compare=that
 */
Handlebars.registerHelper('unless_lteq', function(context, options) {
  if (context <= options.hash.compare)
    return options.inverse(this);
  return options.fn(this);
});

/**
 * Convert new line (\n\r) to <br>
 * from http://phpjs.org/functions/nl2br:480
 */
Handlebars.registerHelper('nl2br', function(text) {
  text = Handlebars.Utils.escapeExpression(text);
  var nl2br = (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br>' + '$2');
  return new Handlebars.SafeString(nl2br);
});

/**
 * If value is contained in an array
 *
 */
Handlebars.registerHelper("if_contains", function( value, array, options ) {
  if (!Array.isArray(array)) {
    array = [array];
  }
	return (array.indexOf(value) > -1) ? options.fn( this ) : "";
});

/**
 * The {{#exists}} helper checks if a variable is defined.
 */
Handlebars.registerHelper('exists', function(variable, options) {
    if (typeof variable !== 'undefined') {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
});

/**
 * The {{#if_defined}} helper checks if a variable is not equal to null.
 * If the value is not null, the content within the block is rendered.
 * Otherwise, if an {{else}} block is present, its content is rendered.
 */
Handlebars.registerHelper('if_defined', function (value, options) {
  if (value !== null && value !== undefined) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
});

/**
 * Splits ip address 'xxx.xxx.xxx.xxx' into 4 'xxx' parts and returns one of them
 */
Handlebars.registerHelper('get_ip_part', function (ip, number) {
  if (typeof(ip) != 'string') {
    return '';
  }

  var parts = ip.split('.');
  if (parts.length > number) {
    return parts[number];
  }

  return '';
});

/**
 * If a custom CC error is thrown, accordingly build error message with a link,
 * otherwise display an error message as is
 */
Handlebars.registerHelper('custom_message', function (message) {
  var output = '';
  try{
    var obj = JSON.parse(message);
    output = obj.text + ' '
             + '<a href="javascript:void(0)" data-client-id=' + obj.client_id
             + ' data-vo-id=' + obj.vo_id + '>'
             + obj.link
             + '</a>';
  }
  catch(e){
    output = message;
  }

  return new Handlebars.SafeString(output);
});

Handlebars.registerHelper('join_errors', function (message) {
  var output = message.join().split(',').join('<br />')
  return new Handlebars.SafeString(output);
});

var escapeHTML = function (raw_str) {
  if (raw_str) {
    return raw_str.replace(/&(?![#\w]+;)/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
  return '';
}

Handlebars.registerHelper('create_ax_tooltip_content', function (content) {
  return escapeHTML(content);
});

Handlebars.registerHelper("debug", function(optionalValue) {
  console.log(this);
  if (optionalValue) {
    console.log(optionalValue);
  }
});

Handlebars.registerHelper('ifCond', function(v1, v2, options) {
  if(v1 === v2) {
    return options.fn(this);
  }
  return options.inverse(this);
});